<template>
    <div class="container" v-if="show" :style="{marginBottom:$route.name=='page'?'0px':'-15px'}">
        <a-alert banner closable style="margin:10px 0" v-for="(message, index) in alerts" :key="index">
            <div slot="message" v-html="message"></div>
        </a-alert>
    </div>
</template>

<script>
import {Alert} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Alert)
export default {
    mounted() {
        this.getAlert()
    },
    methods: {
        getAlert() {
            this.$service.getData(this.$service.api.common.alert, {project:this.$service.PROJ_CODE}).then((data)=>{
                if(data.show === true) {
                    this.alerts = data.alerts
                    this.show = true
                }
                else {
                    this.show = false
                    this.alerts = []
                }
            }).catch((data)=> {
                this.show = false
                this.alerts = []
            })
        },
    },
    data() {
        return {
            show: false,
            alerts: [],
        }
    }
}
</script>